export default "__VITE_ASSET__DCT5LOKL__"